/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown>, name: NonNullable<unknown>, time: NonNullable<unknown> }} Order_Payment_Method_Change_HistoryInputs */

const vi_order_payment_method_change_history = /** @type {(inputs: Order_Payment_Method_Change_HistoryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đổi từ ${i?.from} sang ${i?.to} · ${i?.name} · ${i?.time}`)
};

/**

* @param {Order_Payment_Method_Change_HistoryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_payment_method_change_history = /** @type {((inputs: Order_Payment_Method_Change_HistoryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Payment_Method_Change_HistoryInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_payment_method_change_history(inputs)
});